//#region components/button_group/button_group_constants.js
var e = {
	start: "d-btn-group--start",
	end: "d-btn-group--end",
	"space-between": "d-btn-group--space-between"
};
//#endregion
export { e as BUTTON_GROUP_ALIGNMENT };

//# sourceMappingURL=button-group-constants.js.map